import React from "react"
import PageBanner from "../Components/PageBanner";
import Admissionform from "../Components/Admissionform"

const Admissionformp = () => {
    return (
        <div className="pt-20 bg-[#F6F5F1]">
            <PageBanner eyebrow="Admissions" title="Apply for admission" />
            <Admissionform />
        </div>
    )
}

export default Admissionformp;